import {useSelector} from "react-redux";
import AxiosIndicatorRunTimeLoader from "../../component/AxiosIndicatorRunTimeLoader";
import React from "react";
import {isArray, isString} from "underscore";

export function useAxiosIndicatorCheck() {
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    const __check = (running_axios_slug, props, axios_indicator_deep_scoped = false) => {
        let axios_indicator_here = {};
        if (axios_indicator_deep_scoped !== false) {
            axios_indicator_here = axios_indicator_deep_scoped;
        } else {
            axios_indicator_here = axios_indicator;
        }
        if (isArray(running_axios_slug)) {
            let true_count = 0;
            running_axios_slug.map((v) => {
                if (axios_indicator_here[v] !== undefined) {
                    true_count++
                }
            });
            let f_status = false;
            if (true_count > 0) {
                f_status = true;
            }
            let ele = false;
            if (f_status) {
                ele = <AxiosIndicatorRunTimeLoader {...props}/>;
            }
            return {
                status: f_status,
                render: ele,
            }
        }
        if (isString(running_axios_slug)) {
            let status = axios_indicator_here[running_axios_slug] !== undefined;
            let ele = false;
            if (status) {
                ele = <AxiosIndicatorRunTimeLoader {...props}/>;
            }
            return {
                status: status,
                render: ele,
            }
        }
        return {
            status: false,
            render: false,
        }
    };
    return [__check];
}